<template>
    <template v-if="src">
        <button type="button" class="widget-panel-toggle" :class="{ 'widget-panel-toggle-open': isOpen, 'widget-panel-toggle-expanded': isOpen && isExpanded }" :title="$t(isOpen ? 'widgetPanel.close' : 'widgetPanel.open')" @click="toggle">
            <img src="/img/logo/faviconv.svg" class="widget-panel-toggle-logo" alt="">
        </button>
        <Transition name="widget-panel">
            <div v-show="isOpen" class="widget-panel" :class="{ 'widget-panel-expanded': isExpanded }">
                <div class="widget-panel-header">
                    <span class="font-weight-semibold">{{ $t('widgetPanel.title') }}</span>
                    <div class="d-flex">
                        <button type="button" class="widget-panel-button" :title="$t(isExpanded ? 'widgetPanel.collapse' : 'widgetPanel.expand')" @click="isExpanded = !isExpanded">
                            <i :class="isExpanded ? 'icon-shrink7' : 'icon-enlarge7'"></i>
                        </button>
                        <button type="button" class="widget-panel-button" :title="$t('widgetPanel.close')" @click="isOpen = false">
                            <i class="icon-cross2"></i>
                        </button>
                    </div>
                </div>
                <iframe v-if="isLoaded" ref="frame" :src="src" class="widget-panel-frame" @load="sendRoute" allow="clipboard-read; clipboard-write; microphone"></iframe>
            </div>
        </Transition>
    </template>
</template>
<script>
import {httpClient} from "../../services/HttpClient";

export default {
    name: 'WidgetPanel',
    data() {
        return {
            widget: null,
            isOpen: false,
            isExpanded: false,
            isLoaded: false,
        }
    },
    computed: {
        src() {
            const project = this.$store.state.route.project;

            if (!this.widget || !project) {
                return null;
            }

            const url = new URL(this.widget.url);
            url.searchParams.set('token', this.widget.token);
            url.searchParams.set('project_uuid', project.uuid);

            if (this.widget.fs_lead_id) {
                url.searchParams.set('fs_lead_id', this.widget.fs_lead_id);
            }

            return url.toString();
        },
    },
    async created() {
        const response = await httpClient.get('/profile/widget');

        this.widget = response.data.data;
    },
    watch: {
        '$route.fullPath'() {
            this.sendRoute();
        },
    },
    methods: {
        toggle() {
            this.isLoaded = true;
            this.isOpen = !this.isOpen;
        },
        sendRoute() {
            this.$refs.frame?.contentWindow.postMessage({
                type: 'route',
                name: this.$route.name,
                path: this.$route.fullPath,
            }, new URL(this.widget.url).origin);
        },
    },
}
</script>
<style scoped>
.widget-panel-toggle {
    position: fixed;
    top: 90%;
    right: 0;
    z-index: 1041;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 0;
    border-radius: 4px 0 0 4px;
    background: #3f51b5;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    transition: right 0.3s ease;
}

.widget-panel-toggle:focus,
.widget-panel-button:focus {
    outline: 0;
}

.widget-panel-toggle-logo {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
}

.widget-panel-toggle-open {
    right: min(400px, 100vw - 44px);
}

.widget-panel-toggle-expanded {
    right: min(800px, 100vw - 44px);
}

.widget-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1040;
    display: flex;
    flex-direction: column;
    width: 400px;
    max-width: 100vw;
    border-left: 1px solid #ddd;
    background: #fff;
    overflow: hidden;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
    transition: width 0.3s ease;
}

.widget-panel-enter-active,
.widget-panel-leave-active {
    transition: transform 0.3s ease, width 0.3s ease;
}

.widget-panel-enter-from,
.widget-panel-leave-to {
    transform: translateX(100%);
}

.widget-panel-expanded {
    width: 800px;
}

.widget-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem 1rem;
    border-bottom: 1px solid #ddd;
}

.widget-panel-button {
    padding: 0.25rem;
    border: 0;
    background: none;
    color: #777;
}

.widget-panel-frame {
    display: block;
    flex: 1;
    min-height: 0;
    width: 100%;
    border: 0;
}
</style>
